/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PatchPrebidConflictType {
  UnexpectedState = 'unexpected_state',
  CreditLimitExceeded = 'credit_limit_exceeded'
}
